import { AvailableLanguages, availableLanguagesList, LocalizedValue } from 'types/entities'

export const isLocalizedValueEmpty = (value: LocalizedValue) => Object.values(value).every((value) => !value)

export function createLocalizedValue<T = string>(fn: (lang: AvailableLanguages) => T): LocalizedValue<T> {
  return availableLanguagesList.reduce((acc, lang) => ({ ...acc, [lang]: fn(lang) }), {})
}
